import { where } from "firebase/firestore"
import Moment from 'moment'
import { getRevendaIdByPark, getUsuario } from '../../config/auth'
import { Collection, WhereField } from '../../shared/constants'
import { chunkItemsByQuantity } from '../../shared/utils'
import { addDoc, getAllDocs, getAllDocsByClientId, getAllDocsByParkId, getAllDocsByQueries, getCountByQueries, getDocById, getDocByQueries, updateDoc } from './collectionBaseWorker'
import { getFirstPendingChageByMonthlyId, getLastPaidChageByMonthlyId, getLastPendingChageByMonthlyId } from './monthlyChagesWorker'

export const getMonthlyById = async ({ id }) => {
    const monthly = await getDocById({ collection: Collection.MONTHLIES, id: id })
    if (monthly) {
        const firstChange = await getFirstPendingChageByMonthlyId({ monthlyId: monthly.id })
        if (monthly.plano) {
            if (firstChange) {
                const lastChange = await getLastPendingChageByMonthlyId({ monthlyId: monthly.id })
                monthly.plano.dataFatura = firstChange?.changeDate
                monthly.plano.validadeContrato = lastChange?.changeDate
            } else {
                const lastPaid = await getLastPaidChageByMonthlyId({ monthlyId: monthly.id })
                monthly.plano.dataFatura = lastPaid?.changeDate
                monthly.plano.validadeContrato = lastPaid?.changeDate
            }
        }
        return monthly
    }
    return null
}

export const getAllMonthliesByIds = async ({ ids }) => {
    var results = []
    var items = chunkItemsByQuantity({ items: ids })
    for (const idss of items) {
        const result = await getAllDocsByQueries({
            collection: Collection.MONTHLIES,
            queries: [
                where(WhereField.ID, 'in', idss)
            ]
        })
        results.push(result)
    }
    return results.flatMap(e => e)
}

export const getMonthlyByParksIds = async ({ estacionamentosIds }) => {
    var items = []
    const chunkSize = 10;
    for (let i = 0; i < estacionamentosIds.length; i += chunkSize) {
        const estacionamentosSliced = estacionamentosIds.slice(i, i + chunkSize);
        if (estacionamentosSliced.length > 0) {
            const results = await getAllDocsByQueries({
                collection: Collection.MONTHLIES,
                queries: [
                    where(WhereField.PARKID, 'in', estacionamentosSliced)
                ]
            })
            items.push(results)
        }
    }
    return items.flatMap(e => e)
}

export const getAllChargesWithNoCashier = async ({ estacionamentoId }) => {
    const result = await getAllDocsByQueries({
        collection: Collection.MONTHLY_HISTORIES,
        queries: [
            where(WhereField.PARKID, '==', estacionamentoId),
            where(WhereField.CASHIER__ID, '==', "SEM_CAIXA_ABERTO")
        ]
    })
    return result.sort((a, b) => a.changeDate?.toDate() - b.changeDate?.toDate())
}

export const getMonthlyByDocumentAndParkId = async ({ document, estacionamentoId }) => {
    return await getDocByQueries({
        collection: Collection.MONTHLIES,
        queries: [
            where(WhereField.DOCUMENT, '==', document),
            where(WhereField.PARKID, '==', estacionamentoId)
        ]
    })
}

export const getAllMonthliesMigrate = async () => {
    return await getAllDocs({ collection: Collection.MONTHLIES })
}

export const getAllMonthlies = async () => {
    return await getAllDocs({ collection: Collection.MONTHLIES })
}

export const getMonthlyCountByParkId = async ({ estacionamentoId }) => {
    const quantity = await getCountByQueries({
        collection: Collection.MONTHLIES,
        queries: [
            where(WhereField.PARKID, '==', estacionamentoId)
        ]
    })
    return quantity
}

export const getAllMonthlyByClientId = async ({ clienteId }) => {
    return await getAllDocsByClientId({ collection: Collection.MONTHLIES, clienteId: clienteId })
}

export const getAllActivatedMonthlyByParkId = async ({ estacionamentoId, withCharges }) => {
    const monthlies = await getAllMonthlyByParkId({ estacionamentoId: estacionamentoId, withCharges: withCharges })
    return monthlies.filter(e => e.status !== "inativo")
}

export const getAllMonthlyByParkId = async ({ estacionamentoId, withCharges, getInativos }) => {
    const items = await getAllDocsByParkId({ collection: Collection.MONTHLIES, estacionamentoId: estacionamentoId })
    if (withCharges) {
        for (const monthly of items) {
            const firstChange = await getFirstPendingChageByMonthlyId({ monthlyId: monthly.id })
            const lastChange = await getLastPendingChageByMonthlyId({ monthlyId: monthly.id })
            if (monthly.plano) {
                monthly.plano.dataFatura = firstChange?.changeDate
                monthly.plano.validadeContrato = lastChange?.changeDate
            }
        }
    }
    return items.filter(e => getInativos || e.status !== "inativo").sort((a, b) => a.nome.localeCompare(b.nome))
}

export const addMonthly = async ({ clientId, estacionamentoId, nome, documento, tipoDocumento, email, celular, telefone, endereco, dataFatura, diaVencimento, validadeContrato, plano }) => {
    const data = {
        clienteId: clientId,
        estacionamentoId: estacionamentoId,
        nome: nome,
        documento: documento,
        tipoDocumento: tipoDocumento,
        revendaId: getRevendaIdByPark(),
        email: email,
        celular: celular,
        telefone: telefone,
        endereco: {
            cep: endereco?.cep,
            logradouro: endereco?.logradouro,
            numero: endereco?.numero,
            bairro: endereco?.bairro,
            cidade: endereco?.cidade,
            estado: endereco?.estado,
            complemento: endereco?.complemento
        },
        plano: {
            validadeContrato: validadeContrato?.toDate() ?? Moment().add(365, 'days').toDate(),
            dataFatura: dataFatura.toDate(),
            diaVencimento: diaVencimento.toString(),
            horarioFim: plano?.horarioFim,
            horarioInicio: plano?.horarioInicio,
            planoId: plano?.id,
            nome: plano?.nome,
            valor: plano?.valorMensal
        },
        createdAt: new Date(),
        createdBy: getUsuario().email,
        isDeleted: false,
    }
    const doc = addDoc({ collection: Collection.MONTHLIES, data: data })
    return doc.id
}

export const getAllMonthliesByPlanId = async ({ planId, estacionamentoId }) => {
    const result = await getAllDocsByQueries({
        collection: Collection.MONTHLIES,
        queries: [
            where(WhereField.PARKID, '==', estacionamentoId),
            where("plano.planoId", '==', planId)
        ]
    })
    return result.filter(e => e.status !== "inativo")
}

export const updateVencimentoFatura = async ({ mensalistaId, plano, dataFatura }) => {
    const data = {
        plano: {
            ...plano,
            dataFatura: dataFatura
        }
    }
    await updateDoc({ collection: Collection.MONTHLIES, id: mensalistaId, data: data })
}

export const updateMonthlyById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.MONTHLIES, id: id, data: data })
}

export const updateValidadeContrato = async ({ mensalistaId, validadeContrato }) => {
    var plano = {
        validadeContrato: validadeContrato
    }
    const data = {
        plano: plano
    }
    await updateDoc({ collection: Collection.MONTHLIES, id: mensalistaId, data: data })
}

export const updateDueDate = async ({ mensalistaId, plano, dueDate }) => {
    const data = {
        plano: {
            ...plano,
            dataFatura: dueDate
        }
    }
    await updateDoc({ collection: Collection.MONTHLIES, id: mensalistaId, data: data })
}